import BaseModel from "./BaseModel";
import dayjs from "dayjs";
import AccommodationUnit from "./AccommodationUnit";
import Image from "./Image";
import AccommodationContact from "./AccommodationContact";
import AccommodationReview from "./AccommodationReview";
import PlaceAttraction from "./PlaceAttraction";
import Accommodation from "./Accommodation";

export default class AccommodationReservation extends BaseModel {

    private _type: string = "";
    private _date_from: Date;
    private _date_to: Date;
    private _total_price: number = 0;
    private _deposit: number = 0;
    private _id_guest: number = 0;
    private _id_client: number = 0;
    private _temp: boolean = false;
    private _note: string = '';
    private _pets: string = '';
    private _chat_room: string = '';
    private _currency: string = 'EUR';
    private _origin_type: string = 'internal';
    private _source: string | null = null;
    private _id_accommodation_units: number[] = [];
    private _guest_data: { [k: string]: string } = {};
    private _object: Accommodation = new Accommodation();
    private _guests: { adult: number, child: number, newborn: 0 } = {adult: 0, child: 0, newborn: 0};

    get combinedNoteWithPets() {
        return (this.note && this.note.length > 0 ? this.note : '') + ' ' + (this.pets && this.pets.length > 0 ? this.pets : '');
    }

    get type(): string {
        return this._type;
    }

    set type(value: string) {
        this._type = value;
    }

    get date_from(): Date {
        return this._date_from;
    }

    set date_from(value: Date) {
        this._date_from = value;
    }

    get date_to(): Date {
        return this._date_to;
    }

    set date_to(value: Date) {
        this._date_to = value;
    }

    get id_accommodation_units(): number[] {
        return this._id_accommodation_units;
    }

    set id_accommodation_units(value: number[]) {
        this._id_accommodation_units = value;
    }


    get guest_data(): { [p: string]: string } {
        return this._guest_data;
    }

    set guest_data(value: { [p: string]: string }) {
        this._guest_data = value;
    }

    get total_price(): number {
        return this._total_price;
    }

    set total_price(value: number) {
        this._total_price = value;
    }

    get deposit(): number {
        return this._deposit;
    }

    set deposit(value: number) {
        this._deposit = value;
    }

    get note(): string {
        return this._note;
    }

    set note(value: string) {
        this._note = value;
    }

    get pets(): string {
        return this._pets;
    }

    set pets(value: string) {
        this._pets = value;
    }

    get currency(): string {
        return this._currency;
    }

    set currency(value: string) {
        this._currency = value;
    }


    get guests(): { adult: number; child: number; newborn: 0 } {
        if (typeof this._guests !== 'object' || Object.keys(this._guests).length !== 3) {
            return {adult: 0, child: 0, newborn: 0};
        } else {
            return this._guests;
        }
    }

    set guests(value: { adult: number; child: number; newborn: 0 }) {
        this._guests = value;
    }

    get actualStatus(): string {
        const today = dayjs().hour(0).minute(0).second(0);
        if (dayjs(this.date_from).diff(today) < 0 && dayjs(this.date_to).diff(today) > 0) {
            return "in-present";
        } else if (dayjs(this.date_from).diff(today) > 0) {
            return "in-future"
        } else {
            return 'in-past'
        }
    }

    get object(): Accommodation {
        return this._object;
    }

    set object(value: Accommodation) {
        this._object = value;
    }

    get chat_room(): string {
        return this._chat_room;
    }

    set chat_room(value: string) {
        this._chat_room = value;
    }

    get id_guest(): number {
        return this._id_guest;
    }

    set id_guest(value: number) {
        this._id_guest = value;
    }

    get id_client(): number {
        return this._id_client;
    }

    set id_client(value: number) {
        this._id_client = value;
    }

    get temp(): boolean {
        return this._temp;
    }

    set temp(value: boolean) {
        this._temp = value;
    }


    get reservedUnits(): Array<AccommodationUnit> {
        return this.object && this.object.units && this.object.units.length > 0 ? this.object.units.filter(u => this.id_accommodation_units.indexOf(u.id) > -1) : []
    }

    public getTotalGuestsCount(): number {
        return Number(this.guests.adult) + Number(this.guests.child) + Number(this.guests.newborn);
    }

    public getGuestsKidsCount(): number {
        return Number(this.guests.child) + Number(this.guests.newborn);
    }


    get origin_type(): string {
        return this._origin_type;
    }

    set origin_type(value: string) {
        this._origin_type = value;
    }

    get source(): string | null {
        return this._source;
    }

    set source(value: string | null) {
        this._source = value;
    }
}
